const DEFAULT_TIMEOUT = 15000

const ANONYMOUS_URL_KEYWORDS = [
  '/login',
  '/captcha/',
  '/api/captcha/'
]

function normalizeUrl (url) {
  return url == null ? '' : String(url)
}

function isAuthRequired (url) {
  const normalizedUrl = normalizeUrl(url)
  return !ANONYMOUS_URL_KEYWORDS.some(keyword => normalizedUrl.includes(keyword))
}

function isFormData (value) {
  return typeof FormData !== 'undefined' && value instanceof FormData
}

function isUrlSearchParams (value) {
  return typeof URLSearchParams !== 'undefined' && value instanceof URLSearchParams
}

function stableStringify (value) {
  if (value == null) {
    return ''
  }
  if (isFormData(value)) {
    return '[form-data]'
  }
  if (isUrlSearchParams(value)) {
    return value.toString()
  }
  if (Array.isArray(value)) {
    return '[' + value.map(item => stableStringify(item)).join(',') + ']'
  }
  if (typeof value === 'object') {
    return '{' + Object.keys(value).sort().map(key => key + ':' + stableStringify(value[key])).join(',') + '}'
  }
  return String(value)
}

function buildRequestKey (config) {
  const method = (config && config.method ? config.method : 'get').toLowerCase()
  const baseURL = config && config.baseURL ? config.baseURL : ''
  const url = normalizeUrl(config && config.url)
  const params = stableStringify(config && config.params)
  const data = stableStringify(config && config.data)

  return [method, baseURL, url, params, data].join('&')
}

function isBlobData (data) {
  return typeof Blob !== 'undefined' && data instanceof Blob
}

function parseStringMessage (data) {
  if (!data || typeof data !== 'string') {
    return ''
  }
  try {
    const parsed = JSON.parse(data)
    return parsed.msg || parsed.message || data
  } catch (error) {
    return data
  }
}

function resolveErrorMessage (error) {
  const response = error && error.response
  const data = response && response.data

  if (data && typeof data === 'object' && !isBlobData(data)) {
    return data.msg || data.message || error.message || '请求失败，请稍后重试'
  }

  const stringMessage = parseStringMessage(data)
  if (stringMessage) {
    return stringMessage
  }

  if (response && response.status === 401) {
    return '登录已失效，请重新登录'
  }
  if (response && response.status === 403) {
    return '无权限访问'
  }
  if (response && response.status >= 500) {
    return '服务器异常，请稍后重试'
  }

  return (error && error.message) || '请求失败，请稍后重试'
}

module.exports = {
  DEFAULT_TIMEOUT,
  buildRequestKey,
  isAuthRequired,
  resolveErrorMessage,
  stableStringify
}
